export default "__VITE_ASSET__087a07b1__"